"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLinkDisplayComponent = exports.UserTextDisplayComponent = exports.getUserUrlForDisplay = exports.getUserNameForDisplay = exports.isUserActive = exports.isUserInfoVisible = exports.UserNameText = exports.DefaultHiddenUserElement = exports.DefaultNoneUserElement = exports.UserPlaceholderStyle = void 0;
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../gen-src/Localize");
var SiteUrlsContext_1 = require("./urls/SiteUrlsContext");
/** This matches the HiddenUserStyle in VizPortalClient */
exports.UserPlaceholderStyle = {
    color: '#BFBFBF',
    fontWeight: 'inherit'
};
function DefaultNoneUserElement() {
    return react_1.default.createElement("span", { style: exports.UserPlaceholderStyle }, Localize_1.Messages.None());
}
exports.DefaultNoneUserElement = DefaultNoneUserElement;
function DefaultHiddenUserElement() {
    return react_1.default.createElement("span", { style: exports.UserPlaceholderStyle }, Localize_1.Messages.HiddenUser());
}
exports.DefaultHiddenUserElement = DefaultHiddenUserElement;
function UserNameText(props) {
    return react_1.default.createElement("span", null, props.name);
}
exports.UserNameText = UserNameText;
function isUserInfoVisible(user) {
    // Some fields may still possibly be empty string, which is still "visible"
    return user.domain !== null || user.name !== null || user.username !== null;
}
exports.isUserInfoVisible = isUserInfoVisible;
function isUserActive(user) {
    return user.domain !== null && user.username !== null;
}
exports.isUserActive = isUserActive;
function getUserNameForDisplay(user) {
    // The name should always be defined for these types, but the previous
    // code fell back to username so we're preserving that logic here, just in case
    // some client code doesn't have strict null checks.
    return user.name || user.username || '';
}
exports.getUserNameForDisplay = getUserNameForDisplay;
function getUserUrlForDisplay(urls, user) {
    return urls.userUrl(user.username, user.domain);
}
exports.getUserUrlForDisplay = getUserUrlForDisplay;
function getUserPathForDisplay(urls, user) {
    return urls.userPath(user.username, user.domain);
}
function UserTextDisplayComponent(props) {
    if (!props.user) {
        return props.noneUserElement || react_1.default.createElement(DefaultNoneUserElement, null);
    }
    else if (!isUserInfoVisible(props.user)) {
        return props.hiddenUserElement || react_1.default.createElement(DefaultHiddenUserElement, null);
    }
    else {
        var name_1 = getUserNameForDisplay(props.user);
        return react_1.default.createElement(UserNameText, { name: name_1 });
    }
}
exports.UserTextDisplayComponent = UserTextDisplayComponent;
function UserLinkDisplayComponent(_a) {
    var user = _a.user, props = __rest(_a, ["user"]);
    var urls = react_1.default.useContext(SiteUrlsContext_1.SiteUrlsContext);
    if (!user) {
        return props.noneUserElement || react_1.default.createElement(DefaultNoneUserElement, null);
    }
    else if (!isUserInfoVisible(user)) {
        return props.hiddenUserElement || react_1.default.createElement(DefaultHiddenUserElement, null);
    }
    else if (!isUserActive(user)) {
        return react_1.default.createElement(UserNameText, { name: user.name });
    }
    else {
        var name_2 = getUserNameForDisplay(user);
        var url = getUserUrlForDisplay(urls, user);
        var path = getUserPathForDisplay(urls, user);
        return react_1.default.createElement(props.linkComponent, { name: name_2, url: url, pathname: path });
    }
}
exports.UserLinkDisplayComponent = UserLinkDisplayComponent;
//# sourceMappingURL=UserDisplayComponent.js.map